import { gsap } from "gsap";

import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);

document.addEventListener("DOMContentLoaded", function() {
    if (document.getElementById("homepage-banner-squiggly-lines")) {
        document.getElementById("homepage-banner-squiggly-lines").classList.remove("hidden");

        const paths = document.querySelectorAll("#homepage-banner-squiggly-lines path");
        paths.forEach(path => {
            gsap.fromTo(path, {drawSVG: "0%"}, {duration: 2, drawSVG: "100%"});
        });
    }
});
